import { render } from "./SettingsDatatableTDNotificationRole.vue?vue&type=template&id=61fba1a8"
import script from "./SettingsDatatableTDNotificationRole.vue?vue&type=script&lang=js"
export * from "./SettingsDatatableTDNotificationRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__